import React from 'react';
import { compact } from 'lodash';

import { MapFragment } from '../../../../graphql.schema';
import Map from '../../Map';

export const StrapiMap: React.FC<MapFragment> = (props) => {
  return (
    <div className="my-5">
      <Map
        markers={compact(props.markers?.map((map) => ({
          ...map,
          popUpHtml: map?.mapLocation?.pop_up_html ?? '',
          lat: map?.mapLocation?.latitude ?? 0,
          lng: map?.mapLocation?.longitude ?? 0
        })))}
        width={props.width}
        height={props.height}
        defaultZoom={props.defaultZoom}
        mapOptions={{
          scrollwheel: false,
          streetViewControl: false,
          fullscreenControl: false,
          mapTypeControl: false,
          scaleControl: false,
          panControl: false,
          rotateControl: false,
          clickableIcons: false,
          styles: [
            {
              stylers: [{ visibility: 'simplified' }],
            },
          ],
        }}
      />
    </div>
  );
};
